import { Link } from 'react-router'
import { SiteFooter } from '@/components/layout/SiteFooter'
import { SiteHeader } from '@/components/layout/SiteHeader'
import { buttonClassName } from '@/components/ui/buttonStyles'
import { HandNote } from '@/components/design/HandDrawn'
import { IconArrowLeft } from '@/components/Icons'
import { cn } from '@/lib/utils'

export function NotFound() {
  return (
    <>
      <SiteHeader />
      <main className="relative flex min-h-[80vh] flex-col items-center justify-center gap-5 overflow-hidden px-4 pt-24 text-center">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-grid [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]"
        />
        <div
          aria-hidden="true"
          className="relative font-display text-[clamp(110px,22vw,200px)] font-bold leading-none tracking-[-0.06em] text-white/[0.06]"
        >
          404
        </div>
        <h1 className="relative -mt-8 font-display text-3xl font-bold tracking-[-0.02em] text-[var(--text-strong)]">
          Page not found
        </h1>
        <p className="relative max-w-[420px] text-[var(--surface-muted)]">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <HandNote className="relative -rotate-2">let&apos;s get you back on track</HandNote>
        <Link
          to="/"
          className={cn(
            buttonClassName({ variant: 'accent', size: 'lg' }),
            'relative rounded-full px-6',
          )}
        >
          <IconArrowLeft size={16} aria-hidden="true" />
          Back to Home
        </Link>
      </main>
      <SiteFooter />
    </>
  )
}
